/**
 * TealerLab — View Transitions handler pour cards TLR
 * ────────────────────────────────────────────────────
 * Pont entre les cards TLR (.tlr-pcard) et le système View Transitions
 * natif de Horizon (assets/view-transitions.js).
 *
 * Quand l'user clique sur une card produit, on marque la card comme l'origine
 * de la transition. Horizon's pageswap listener (déjà en place) lit ce flag
 * et active le type "product-image-transition" qui fait morpher l'image de
 * la card vers la hero image de la PDP.
 *
 * Compat : Chrome 126+, Safari 18+, Edge 126+. Firefox = no-op silencieux.
 * RGPD/perf : aucun tracking, aucun fetch. Pur DOM manipulation.
 */
(function () {
  // Skip si pas de support View Transitions API ou reduced-motion
  if (typeof document.startViewTransition !== 'function') return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  /**
   * Gère le clic sur une card produit TLR.
   * Marque la media de la card pour que view-transitions.js (Horizon) active
   * le type 'product-image-transition' au pageswap.
   * @param {MouseEvent} event
   */
  function handleCardClick(event) {
    if (event.defaultPrevented) return;

    // Ne pas déclencher la transition si l'user a cliqué sur un élément
    // interactif intérieur (ATC, pill variant, etc.)
    if (event.target instanceof Element) {
      const interactive = event.target.closest(
        'button, input, label, select, [tabindex="1"], [data-no-transition]'
      );
      if (interactive) return;
    }

    const link = event.currentTarget;
    if (!(link instanceof HTMLElement)) return;

    // L'élément qui va morpher : la card __media qui contient l'image active
    const cardMedia = link.matches('.tlr-pcard__media')
      ? link
      : link.closest('.tlr-pcard')?.querySelector('.tlr-pcard__media');
    if (!cardMedia) return;

    cardMedia.setAttribute('data-view-transition-type', 'product-image-transition');
    cardMedia.setAttribute('data-view-transition-triggered', 'true');
  }

  // Délégation : listen sur tous les liens TLR existants ET futurs (AJAX-loaded grids)
  function bindCards(root = document) {
    root.querySelectorAll('[data-tlr-pcard-link]:not([data-tlr-vt-bound])').forEach((link) => {
      link.setAttribute('data-tlr-vt-bound', '');
      link.addEventListener('click', handleCardClick);
    });
    // Le titre cliquable (lien séparé sous la card) déclenche aussi la transition
    root.querySelectorAll('.tlr-pcard__name:not([data-tlr-vt-bound])').forEach((link) => {
      link.setAttribute('data-tlr-vt-bound', '');
      link.addEventListener('click', handleCardClick);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => bindCards());
  } else {
    bindCards();
  }

  // Re-bind après les AJAX reloads du filter section (Section Rendering API)
  // Le grid section est remplacé par innerHTML → re-scanner les nouveaux liens
  const observer = new MutationObserver((mutations) => {
    for (const m of mutations) {
      for (const node of m.addedNodes) {
        if (node.nodeType === 1) bindCards(node);
      }
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();
